/**
 * The dispatch container can never carry linked technicians or labels, so it
 * is never a valid bulk-edit target.
 */
export function isBulkSelectable(containerId: string): boolean {
  return containerId !== "dispatch";
}

/**
 * Applies one click to a container selection: toggles `clickedId` in or out.
 * Non-selectable containers (see `isBulkSelectable`) are ignored entirely.
 *
 * Selection is click-to-toggle only. Shift-range selection was tried and
 * dropped: "between" follows the order containers were added to the layout,
 * not their position on the canvas, so ranges selected unexpected tiles.
 */
export function toggleContainerSelection(
  selectedIds: string[],
  clickedId: string
): string[] {
  if (!isBulkSelectable(clickedId)) return selectedIds;
  return selectedIds.includes(clickedId)
    ? selectedIds.filter((id) => id !== clickedId)
    : [...selectedIds, clickedId];
}
